import { render, staticRenderFns } from "./ServicesItemView.vue?vue&type=template&id=d87729ae&"
import script from "./ServicesItemView.vue?vue&type=script&lang=js&"
export * from "./ServicesItemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports